<template>
  <footer class="footer-container">
    <div class="footer-info">
      <div class="map-list">
        <div class="label-item" v-for="item in mapList" :key="item.label">
          <p class="label">{{item.label}}</p>
          <div class="link-list">
            <div class="link-item" v-for="link in item.linkList" :key="link.label">
              <a v-if="link.link" target="_blank" :href="link.link">{{link.label}}</a>
              <a v-else-if="link.router" @click="$router.push(link.router)">{{link.label}}</a>
              <a v-else href="">{{ link.label }}</a>
              <template v-if="link.subLabel">
                <br/>
                <a target="_blank" :href="link.link">{{ link.subLabel }}</a>
              </template>
            </div>
          </div>
        </div>
        <div class="label-item qr-code">
          <img src="../assets/images/qrCode.png" alt="">
          <p class="intro">一 扫描二维码了解更多 一</p>
          <p class="desc">至臻品质 优质服务</p>
        </div>
      </div>
    </div>
    <p class="copy-right">Copyright © 2019-2025 曼世（MUSION）   All Rights Reserved. 备案号：浙ICP备19044049号-1</p>
  </footer>
</template>

<script>
export default {
data() {
  return {
    mapList: [
      {
        label: '品牌合作',
        linkList: [
          {
            label: '加盟曼世',
            link: 'http://biaodan.kfzxz.com/index.php?m=Order&tpl=detail&id=3NJ7dZ'
          },
          {
            label: '官方授权经销商',
            link: '',
            router: 'Dealer',
          }
        ]
      },
      {
        label: '关注曼世',
        linkList: [
          {
            label: '天猫商城',
            link: 'https://musion.tmall.com/'
          },
          {
            label: '微信公众号',
            link: 'http://mp.weixin.qq.com/mp/homepage?__biz=MzkyMzc3MzkwOA==&hid=1&sn=9445fe6de6da5b5f693bec23b5ed6920&scene=18#wechat_redirect'
          },
          // {
          //   label: '微信小程序',
          //   link: ''
          // },
          {
            label: '曼世订货系统',
            link: 'https://musion.zuiqipei.com/#/logins'
          }
        ]
      },
      {
        label: '关于曼世',
        linkList: [
          {
            label: '曼世售后',
            // link: 'https://mp.weixin.qq.com/s/5JZNXh65oXdm0TMLGtcviA',
            link: '',
            router: 'Service'
          },
          {
            label: '真伪查询',
            link: '',
            router: 'AntiFake'
          },
        ]
      },
      {
        label: '联系我们',
        linkList: [
          {
            label: 'stefan@musion-cn.com',
            link: ''
          },
          {
            label: '曼世服务热线：400-0081075',
            subLabel: '每天09:00-17:00',
            link: ''
          },
          {
            label: '曼世售后服务热线：400-0081075',
            subLabel: '每天09:00-17:00',
            link: ''
          },
          {
            label: '地址：浙江省杭州市余杭区鲲鹏中心7号楼',
            link: ''
          },
        ]
      },
    ]
  }
}
}
</script>

<style lang="scss" scoped>
.footer-container {
  background-color: #f5f5f5;
  .map-list {
    display: flex;
    justify-content: space-evenly;
    padding: 3vw 0;
    .label-item {
      .label {
        font-family: Source Han Sans CN;
        font-weight: 500;
        font-size: 1.0417vw;
        color: #333;
        line-height: 1.3021vw;
      }
      .link-item {
        font-family: Source Han Sans CN;
        font-weight: 400;
        font-size: .8333vw;
        line-height: .9375vw;
        margin-top: 1.2em;
        a {
          color: #999999 !important;
          cursor: pointer;
        }
        p {
          color: #999999 !important;
          line-height: 2em;
        }
      }
    }
    .qr-code {
      display: flex;
      flex-direction: column;
      align-items: center;
      img {
        width: 8.8542vw;
      }
      .intro {
        font-size: .5729vw;
        font-weight: 500;
        color: #999999;
      }
      .desc {
        font-weight: bold;
        font-size: .7292vw;
        color: #333;
        margin-top: .5208vw;
      }
    }
  }
  .copy-right {
    text-align: center;
    font-family: Source Han Sans CN;
    font-size: .9375vw;
    color: #999999;
    height: 5.2083vw;
    line-height: 5.2083vw;
    border-top: 1px solid #bbb;
  }
}
</style>